<footer class="footer-container">
    <section
      class="footer-grid">
      <article class="brand">
        <img [src]="footerContent.image?.url ?? ''" [alt]="footerContent.image?.ariaLabel" class="brand-logo" data-testid="brandLogo"/>
      </article>
      <article class="footer-links-section">
        <div [innerHTML]="footerContent.sectionOneTitle" class="footer-link-header"></div>
        <span [innerHTML]="footerContent.sectionOneDetails" class="footer-link-disclaimer"></span>
      </article>
      <article class="support-details">
        <div [innerHTML]="footerContent.sectionTwoTitle" class="support-details-header"></div>
        <div [innerHTML]="footerContent.sectionTwoDetails" class="support-details-info"></div>
      </article>
      <span [innerHTML]="footerContent.copyright" class="copyright"></span>
    </section>
  </footer>
